/**
 * Shared Chart.js tooltip options aligned with Design System tokens.
 * Use for V2 charts (e.g. investments pie). Merge overrides for chart-specific callbacks.
 *
 * DS alignment:
 * - Font: Hanken Grotesk (--font-sans)
 * - Size: 14px (type-body-s)
 * - Colors: white bg, black text, separator border (#d9e0e0)
 */

const DS_FONT_FAMILY = "'Hanken Grotesk', brandon-grotesque, 'Helvetica Neue', Helvetica, Arial, sans-serif"
const DS_FONT_SIZE = 14
const DS_BG = "#FFF"
const DS_TEXT = "black"
const DS_BORDER = "#d9e0e0"

export const chartTooltipDefaults = {
  backgroundColor: DS_BG,
  titleFontFamily: DS_FONT_FAMILY,
  bodyFontFamily: DS_FONT_FAMILY,
  titleFontSize: DS_FONT_SIZE,
  bodyFontSize: DS_FONT_SIZE,
  titleFontColor: DS_TEXT,
  bodyFontColor: DS_TEXT,
  titleMarginBottom: 8,
  xPadding: 10,
  yPadding: 14,
  displayColors: false,
  borderWidth: 1,
  borderColor: DS_BORDER,
  cornerRadius: 0,
  caretSize: 8,
  caretPadding: 8
}

/**
 * @param {Object} [overrides] - Chart.js tooltip options to merge (e.g. callbacks.label, callbacks.afterBody)
 * @returns {Object} Tooltip options for Chart.js v2 options.tooltips
 */
export function chartTooltipConfig(overrides = {}) {
  return {
    ...chartTooltipDefaults,
    ...overrides,
    callbacks: {
      ...(chartTooltipDefaults.callbacks || {}),
      ...(overrides.callbacks || {})
    }
  }
}
